import React from 'react'
import PrivacyPolicy from '../PrivacyPolicy/PrivacyPolicy'
import Banner from '../Banner/Banner'
import Newsletter from '../Newsletter/Newsletter'

const TermsCondition = () => {
  return (
    <div>
      <PrivacyPolicy />
      <Banner />
      <Newsletter />
    </div>
  )
}

export default TermsCondition
